import { Dropdown } from 'primereact/dropdown';
import React, { useContext, useEffect, useState } from 'react'
import { InvalidError } from '../errors/InvalidError';
import { Panel } from 'primereact/panel';
import { InputTextarea } from 'primereact/inputtextarea';
import { Dialog } from 'primereact/dialog';
import { Button } from 'primereact/button';
import { createComment } from '../../api/axiosComments';
import DataContext from '../../context/DataContext';
import { capitalizeFirstLetter } from '../../utilities/UtilityFunctions';
import { getAllIncidentStatuses } from '../../api/axiosIncidentStatuses';






const CommentForm = ({ 
    commentDialogVisible,
    setCommentDialogVisible,
    incident_id,
    setFetcherror,
    handleAllToasts,
    setComments

}) => {

    const { auntheticatedUser } = useContext(DataContext);


    const user_id = auntheticatedUser?.id
    const operatorinitiated =  (auntheticatedUser?.role === "Admin" || auntheticatedUser?.role === "Operator" || auntheticatedUser?.role === "LHRCstaff") ? true:false 
    const fromName =`${capitalizeFirstLetter(auntheticatedUser?.firstname)} ${capitalizeFirstLetter(auntheticatedUser?.lastname)}` 

    const [errors, setErrors] = useState({});
    const [selectedStatus, setSelectedStatus] = useState("");
    const [incidentStatuses, setIncidentStatuses] = useState([]);
    const [content, setContent] = useState("");
 

    useEffect(( ) => { 
        getAllIncidentStatuses(setIncidentStatuses, setFetcherror);
    },[])


  const handleFormValidation = () => {
    const updatedErrors = {};
    let error = false;
    const validateField = (fieldName, value, regex) => {
        if (!value) {
            updatedErrors[fieldName] = true;
            error = true;
        } else if (regex && !regex.test(value)) {
            updatedErrors[`invalid_${fieldName}`] = true;
            error = true;
        } else {
            updatedErrors[fieldName] = false;
            updatedErrors[`invalid_${fieldName}`] = false;
        }
    };

    const validateYear = (yearValue) => {
        if ( isNaN(yearValue) || parseFloat(yearValue) < 1900) {
            error = true;
            updatedErrors.year = true;
         }
    }
    const numberRegex = /^[0-9]+$/;

    
        validateField('selectedStatus', selectedStatus?.name);
        validateField('content', content);
       
    
    setErrors((err) => ({
        ...err,
        ...updatedErrors
    }));
    return error;
    };
    

    const handleSubmitComment = () => { 

        createComment (
            content,
            setContent,
            fromName,
            selectedStatus,
            setSelectedStatus,
            user_id,
            incident_id,
            setFetcherror,
            handleAllToasts,
            setComments,
            operatorinitiated
        )
    }
  
  
    return (
        <div>
            <Dialog  visible={commentDialogVisible} style={{ width: '30vw' }} onHide={() => setCommentDialogVisible(false)}>
                
                <form action=""
                    
                    onSubmit={(e) => {
                        e.preventDefault();
                       const validationError = handleFormValidation();
                       if (!validationError) { 
                        handleSubmitComment()
                       } 
                     }}
                
                >
                <Panel >

                    <div className='w-full mb-4' >
                        <label htmlFor="status" className="block text-900 font-medium mb-2">Status </label>
                        <Dropdown
                        value={selectedStatus}
                            
                        onChange={(e) => {
                            setSelectedStatus(e.value);
                            setErrors((prev) => ({ ...prev, selectedStatus: false }));
                        }}
                        options={incidentStatuses} optionLabel="name"
                        placeholder=" Select Status "
                        showClear
                        className="w-full"
                        />
                        {errors?.selectedStatus && <InvalidError errorMessage="Status is Required" />}
                    </div>

                    <div className='w-full mb-4'>
                    <label htmlFor="status" className="block text-900 font-medium mb-2">Description </label>
                        <InputTextarea
                            className='w-full h-8rem'
                            autoResize
                            placeholder='Describe the Update'
                            value={content}
                            onChange={(e) => {
                            setContent(e.target.value);
                            setErrors((prev) => ({ ...prev, content: false }));
                        }}
                        />
                        {errors?.content && <InvalidError errorMessage="Description is Required" />}
                        </div>
                    
                        <div className='flex justify-content-end'>
                            <Button
                                role='submit'
                                label='Send'
                                icon="pi pi-save"
                                outlined
                                className='px-4 py-2'
                            />
                        </div>
                        
                </Panel>


            </form>
          </Dialog>

           
          
          
    </div>
  )
}

export default CommentForm